module.exports = __webpack_public_path__ + "img/home_productfive.5e61df6b.jpg";